import React from 'react'
import styled from '@emotion/styled'

import { BuildIcon, EngagingIcon, MobileIcon } from '@segment/matcha/components/Icons/Brandbook'
import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'
import IconWrapper from '@segment/matcha/components/IconWrapper'
import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

const features = [
  {
    title: `Eliminate Redundant Code`,
    description: `Consolidate repetitive user tracking code with a single, simple API.`,
    icon: <BuildIcon size="large" />,
  },
  {
    title: `Shrink your app`,
    description: `Reduce the size of your app by moving destinations to the server-side.`,
    icon: <MobileIcon size="large" />,
  },
  {
    title: `Boost Performance`,
    description: `Save your customers battery with data queuing, batching, and compression.`,
    icon: <EngagingIcon size="large" />,
  },
]

const FeatureBoxGroup = () => (
  <SectionBaseWrapper variant="centered">
    <StyledColumnTrack columns={1} overrides={{ lg: 3 }}>
      {features.map((feature) => (
        <FeatureBoxBase key={feature.title} alignment="left" headerPosition="top">
          <FeatureBox.Header>
            <IconWrapper variant="transparent">{feature.icon}</IconWrapper>
          </FeatureBox.Header>
          <FeatureBox.Body>
            <FeatureBox.Title tag="p">{feature.title}</FeatureBox.Title>
            <FeatureBox.Text>{feature.description}</FeatureBox.Text>
          </FeatureBox.Body>
        </FeatureBoxBase>
      ))}
    </StyledColumnTrack>
  </SectionBaseWrapper>
)

const SectionBaseWrapper = styled(SectionBase)`
  max-width: 1280px;

  ${Section.Wrapper} {
    gap: 0;
    padding-bottom: 30px;
  }
`

const StyledColumnTrack = styled(ColumnTrack)`
  row-gap: 0;
  margin: auto;
  display: flex;
  flex-direction: column;
  gap: 48px;
  align-items: center;

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    display: grid;
    gap: 75px;
    grid-auto-rows: minmax(100px, auto);
    max-width: 1420px;
    align-items: start;
    grid-template-columns: repeat(3, 1fr);
  }
`

export default FeatureBoxGroup
